import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-wrapper" }
const _hoisted_2 = { class: "contact py-4" }
const _hoisted_3 = { class: "contact-item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "contact-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contact-item" }, [
        _createElementVNode("span", { class: "color--primary fw-600" }, " Ficou alguma dúvida? ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          class: "icon mx-1",
          name: "globe"
        }),
        _createElementVNode("a", {
          href: `${
            _ctx.arData.siteAR.includes('https://')
              ? _ctx.arData.siteAR
              : `https://${_ctx.arData.siteAR}`
          }`,
          class: "link"
        }, _toDisplayString(_ctx.getSiteArFormatted), 9, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Icon, {
          class: "icon mx-1",
          name: "phone"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.arData.foneAR), 1)
      ])
    ])
  ]))
}